var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('router-link',{attrs:{"to":{ name: 'dashboard' }}},[_c('el-button',{attrs:{"type":"text","to":{ name: 'dashboard' }}},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/img/logos/logo-v-gray.png")}})])],1),_vm._v(" "),_c('br'),_vm._v("\n  © Saffron App 2019. All Rights Reserved.\n")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-985d164c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = pxVc
// module chunks = 1